




























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DecimalField extends Vue {
  @Prop({ type: Object, required: true }) row!: { [key: string]: string[] };
  @Prop({ type: String }) tip!: string;
  @Prop({ type: Function }) onClick!: Function;
  //Decimal
  @Prop({ type: Number, default: 2 }) decimals!: number;
  //Editable?
  @Prop({ type: Boolean, default: false }) isDisabled!: boolean;
  @Prop({ type: Boolean }) isComponentError!: boolean;

  handleClick() {
    if (this.onClick) {
      this.onClick(this.tip);
    }
  }
}
